import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from '../Global';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const LocalcustomersEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});


  useEffect(() => {
        setPermission(FindModuleById(291)); 
console.log(permission);

    axios
      .get(`/decay-customers/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
       
        setValue(response.data.data.customer);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const {
    values,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      id: value.id,
      name: value.name,
      phone_number: value.phone_number,
      address: value.address,
    },
    enableReinitialize: true,

    onSubmit: (values, actions) => { 
         axios
        .post("/decay-customers/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {

          delete backendErrors['error'];
          $("#form-submit").text("Update Customer");
          actions.setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/local-customers";
            }, 1000);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
         
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Local Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/local-customers">Local Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Customer Information </h4>
                    {permission && permission.update == 1 && (
                        <form action="#" onSubmit={handleSubmit}>
                        <div className="row">
                        <div className="col-md-6">
                              
                              <div className="form-group">
                                <label> Name</label>
                                <input
                                  type="text"
                                  name="name"
                                  value={values.name}
                                  className={
                                    backendErrors.name
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                onBlur={handleBlur}
                                />
                              
                                <small>
                                  {backendErrors.name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.name}
                                    </span>
                                  )}
                                </small> 
                              </div>
                            </div>
                              <div className="col-md-6">
                              
                              <div className="form-group">
                                <label> Phone Number</label>
                                <input
                                  type="text"
                                  name="phone_number"
                                  value={values.phone_number}
                                  className={
                                    backendErrors.phone_number
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                />
                                
                                <small>
                                  {backendErrors.phone_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.phone_number}
                                    </span>
                                  )}
                                </small> 
                              </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                <label>Address</label>
                                <input
                                  type="text"
                                  value={values.address}
                                  name="address"
                                  className={
                                    backendErrors.address
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                />
                                <small>
                                  {backendErrors.address && (
                                    <span className="form-error mt-1">
                                      {backendErrors.address}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            
                        </div>


                        <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}

                            
                            </small>
                              <div className="text-end mt-4">
                                <button
                                  type="submit" id="form-submit"
                                  className="btn btn-primary"
                                  disabled={isSubmitting}
                                >
                                  Update Customer
                                </button>
                              </div>
                        </form>
                        )}
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocalcustomersEdit;
